const adobePageNameMap = {
  '/dashboard': 'dashboard',
  '/hometitle': 'home title',
  '/hometitle/verify': 'home title verify',
  '/alerts': 'alerts inbox',
  '/alerts/archived': 'alerts archived',
  '/alerts/disputed': 'alerts disputed',
  '/alerts/inbox': 'alerts inbox',
  '/alerts/detail': 'alerts',
  '/alertPreferences': 'alert preferences',
  '/credit': 'credit',
  '/credit/efx': 'credit efx',
  '/credit/tu': 'credit tu',
  '/credit/exp': 'credit exp',
  '/credit/card-offer-details': 'credit card offer details',
  '/credit-au': 'credit au',
  '/credit-monitor': 'credit monitor',
  '/locks': 'locks',
  '/locks/freeze': 'locks freeze',
  '/locks/freeze-tax-section': 'locks freeze tax section',
  '/privacyadvisor': 'privacy advisor',
  '/privacymonitor': 'privacy monitor',
  '/transactions': 'transactions',
  '/transactions/accounts': 'transactions',
  '/transactions/all': 'transactions',
  '/transactions/all/search': 'transactions search',
  '/restoration': 'id restoration',
  '/transactions/recurring/all': 'transactions recurring all',
  '/transactions/recurring/details': 'transactions recurring details',
  '/scam-protection': 'scam protection',
  '/scam-protection/financial-details': 'scam protection financial details',
  '/scam-protection/recovery': 'scam protection recovery',
  '/scam-protection/recovery-plan': 'scam protection recovery plan',
  '/scam-protection/claim': 'scam protection claim',
  '/scam-verification': 'scam verification',
  '/card-shield': 'card shield',
  '/card-shield/merchant': 'card shield merchant detail',
  '/card-shield/past-removals': 'card shield past removals',
  '/card-shield/trusted': 'card shield trusted merchants',
  '/estate-planning': 'estate planning',
  '/estate-planning/documents': 'estate planning documents',
  '/estate-planning/notarize': 'estate planning notarize',
  '/estate-planning/fund-trust': 'estate planning fund trust',
  '/monitoring': 'monitored info',
  '/marketplace': 'marketplace',
  '/marketplace/credit': 'marketplace credit',
  '/marketplace/savings': 'marketplace savings',
  '/social-media-monitoring/add-account-success': 'social media monitoring add account success',
  '/social-media-monitoring/add-account-error': 'social media monitoring add account error',
  '/discover': 'discover',
  '/genie': 'genie',
  '/memberchat': 'member chat',
  '/plandetails': 'plan details',
  '/pageNotAvailable': 'page not available',
  '/tuSummaryOfRights': 'tu summary of rights',
  '/summaryOfRights': 'summary of rights',
  '/error': 'error',
  ACTIVATE_CREDIT_MODAL: 'activate credit',
  ADD_PROPERTY_MODAL: 'add property',
  ADOBE_TEST_MODAL: 'adobe test',
  ALERT_DETAILS_MODAL: 'alert detail',
  ALERT_PREF_MODAL: 'alert preferences modal',
  CANCEL_SUBSCRIPTION_MODAL: 'cancel subscription',
  CARD_OFFER_DETAIL_MODAL: 'card offer detail',
  CARD_SHIELD_REMOVAL_EMAIL_TEMPLATE_MODAL: 'card shield removal email template modal',
  CARD_SHIELD_REMOVE_CARD_MODAL: 'card shield remove card',
  CARD_SHIELD_HOW_IT_WORKS_MODAL: 'card shield how it works modal',
  CARD_SHIELD_DASHBOARD_BANNER_INTRO_MODAL: 'card shield dashboard banner intro modal',
  CARD_SHIELD_MERCHANT_TRANSACTION_DETAIL_MODAL: 'card shield merchant transaction detail modal',
  FAMILY_EXPOSURE_MODAL: 'family exposure modal',
  CONSENT_ERROR_MODAL: 'consent error',
  DISCOVER_ENTRY_MODAL: 'discover entry',
  DISCOVER_SHARE_MODAL: 'discover share',
  CREDIT_ERROR_MODAL: 'credit error',
  CREDIT_FREEZE_MODAL: 'credit freeze',
  CREDIT_HISTORY_MODAL: 'credit score history',
  CREDIT_INQUIRIES_MODAL: 'credit inquiries',
  CREDIT_INSIGHTS_MODAL: 'credit insights',
  CREDIT_LOCK_TOGGLE_CONFIRM_MODAL: 'credit lock toggle confirm',
  CREDIT_OFFER_RATINGS_MODAL: 'credit offer ratings',
  CREDIT_OFFERS_CONSENT_MODAL: 'credit offers consent',
  CREDIT_OFFERS_TU_UNLOCK_MODAL: 'credit offers tu unlock',
  CREDIT_OFFERS_PROTECTION_RATING_MODAL: 'credit offers protection rating modal',
  CREDIT_PERSONALIZATION_CONSENT_MODAL: 'credit offers personalization consent',
  CREDIT_PULL_MODAL: 'credit pull',
  CREDIT_REPORT_DOWNLOAD_MODAL: 'download credit report',
  CREDIT_REPORT_INACCURACY_MODAL: 'dispute an error',
  DELETE_FW_INSTITUTION_MODAL: 'delete financial institution',
  DELETE_INSTITUTION_MODAL: 'delete institution',
  EDIT_ADDRESS_MODAL: 'monitor your address',
  EDIT_BANK_ACCOUNT_MODAL: 'monitor your bank',
  EDIT_CREDIT_DEBIT_CARD_MODAL: 'monitor your credit debit card',
  EDIT_DRIVERS_LICENSE_MODAL: 'monitor your driver license',
  EDIT_E_MAIL_ADDR_MODAL: 'monitor your email',
  EDIT_GAMER_TAG_MODAL: 'monitor your gamer tag',
  EDIT_INSURANCE_CARD_MODAL: 'monitor your insurance',
  EDIT_HEALTH_RECORD_MODAL: 'monitor your health record',
  EDIT_LOYALTY_CARD_MODAL: 'monitor your loyalty card',
  EDIT_MOTHERS_MAIDEN_NAME_MODAL: 'monitor your mothers maiden name',
  EDIT_PASSPORT_MODAL: 'monitor your passport',
  EDIT_PHONE_NUMBER_MODAL: 'monitor your phone number',
  ESTATE_PLANNING_ERROR_MODAL: 'estate planning error',
  FCRA_SUCCESS_MODAL: 'fcra success',
  FINAL_WELCOME_MODAL: 'final welcome',
  REIMAGINE_WELCOME_MODAL: 'reimagine welcome',
  FINANCIAL_MONITORING_ACTIVATION_MODAL: 'financial monitoring activation',
  FM_RECONNECT_PROMPT_MODAL: 'financial monitoring reconnect prompt',
  FM_ACCOUNT_LIMIT_MODAL: 'financial monitoring account limit',
  ID_VAULT_APP_DOWNLOAD_MODAL: 'id vault app download',
  LL_APP_DOWNLOAD_MODAL: 'lifelock app download',
  LOCKS_ERROR_MODAL: 'locks error',
  LOCKS_VIDEO_TUTORIAL_MODAL: 'locks video tutorial',
  MA_ACCOUNTS_STATUS_MODAL: 'add account status',
  MA_ALERT_PREF_STATUS_MODAL: 'alert preferences status',
  MA_PERSONAL_INFO_STATUS_MODAL: 'personal info add status',
  MA_PROPERTY_STATUS_MODAL: 'property status',
  MARSH_INSURANCE_OPT_IN_PII_MODAL: 'marsh insurance opt in pii',
  MONITORED_INFO_MODAL: 'monitored info modal',
  NETWORK_ERROR_MODAL: 'network error',
  ONBOARDING_DORMANT_REENGAGE_MODAL: 'onboarding dormant reengage',
  ONBOARDING_ENTRY_MODAL: 'onboarding entry',
  ONBOARDING_REENGAGE_MODAL: 'onboarding reengage',
  PARTNER_MODAL: 'partner',
  PAYMENT_HISTORY_MODAL: 'payment history',
  PRIMARY_PHONE_PROMPT_MODAL: 'primary phone prompt',
  QUEBEC_INSURANCE_OPT_IN_MODAL: 'quebec insurance opt in',
  REMOVE_PROPERTY_MODAL: 'remove property',
  REMOVE_SUPPLEMENTAL_MODAL: 'remove supplemental',
  RESPONSE_MODAL: 'response',
  SCAM_PROTECTION_MODAL: 'scam protection modal',
  SMM_ADD_ACCOUNT_SUCCESS_ERROR_MODAL: 'smm add account success error',
  SMM_ALERT_UPDATE_MODAL: 'smm alert update',
  SMM_CONNECT_ACCOUNT_MODAL: 'smm add account',
  SMM_DELETE_ACCOUNT_MODAL: 'smm delete account',
  SMS_MODAL: 'sms',
  SUCCESS_MODAL: 'success',
  SUMMARY_OF_RIGHTS_MODAL: 'summary of rights modal',
  TRANSACTIONS_ALERT_PREF_MODAL: 'transaction alert preferences',
  TXM_JP_ADD_ACCOUNT_ERROR_MODAL: 'txm jp add account error',
  VANTAGE_SCORE_MODAL: 'vantage score info',
  VERBAL_PASSCODE_MODAL: 'verbal passcode',
  VERIFY_EMAIL_MODAL: 'verify email',
  VERIFY_HOMETITLE_STATUS_MODAL: 'verify home title status',
  VIEW_BALANCES_MODAL: 'view balances',
  WELCOME_MODAL: 'welcome',
  YODLEE_ACCOUNTS_MODAL: 'yodlee accounts',
  YODLEE_DISCLAIMER_MODAL: 'yodlee disclaimer modal',
};
export default {
  adobePageNameMap,
};
